/** Smooth start and finish with continuous velocity and acceleration. */
export function sensorEase(value: number): number {
  const t = Math.max(0, Math.min(1, value));
  return t * t * t * (t * (t * 6 - 15) + 10);
}

export const NIGHT_HAWK_PLATFORM_PITCH = 36;

/** Relative stand-off and height determine tilt and physical slant range. */
export function nightHawkPlatform(seconds: number, controls: { tilt: number; turn: number; climb: number; tempo: number }) {
  const time = seconds * controls.tempo;
  const travel = sensorEase((time - 7) / 15);
  const height = 1 + .65 * controls.climb * sensorEase((time - 9) / 14);
  const radians = NIGHT_HAWK_PLATFORM_PITCH * Math.PI / 180;
  const requestedRange = 1 + 2.3 * controls.tilt * travel;
  const geometricPitch = Math.atan2(requestedRange * Math.tan(radians), height) * 180 / Math.PI;
  const pitch = geometricPitch <= 54 ? geometricPitch : 54 + 14 * Math.tanh((geometricPitch - 54) / 14);
  const slant = height * Math.cos(radians) / Math.cos(pitch * Math.PI / 180);
  return {
    pitch,
    zoom: -Math.log2(slant),
    slantRangeFactor: slant,
    bearing: controls.turn * travel,
    rangeFactor: height * Math.tan(pitch * Math.PI / 180) / Math.tan(radians),
    heightFactor: height,
    travel,
  };
}
